import { useEffect, useState, useRef } from "react";
import LoadingOverlay from "react-loading-overlay-ts";
import moment from "moment";
import PageLayout from "../../PageLayout";
import DesignHeader from "../DesignJobs/DesignHeader";
import FooterButtons from "../DesignJobs/FooterButtons";
import AddNewDesign from "../DesignJobs/TaskHeader";
import { getTaskDetails } from "../../../store/actions/taskDetailAction";
import { submitUploadRegionalDesignIntent } from "../../../apis/uploadSubmitAPIs";
import { postSaveDesignIntent } from "../../../apis/uploadSaveAsDraft";
import { useParams, useNavigate, useLocation } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { uploadtoAzureStrContainer } from "../../../apis/uploadAzuerContainer";
import { Toast } from "primereact/toast";
import {
  viewThumbnail,
  redirectToProjectPlanOrTaskPage,
  sanitizeFileName,
  getEnvironmentFromURL,
} from "../../../utils";
import {
  orderBySequence,
  onFileUpload as fileOnFileUpload,
  onFileClearHandler,
  onAddNewFilesHandler,
  getFilesListObj as fileGetFilesListObj,
} from "../../../Utils/FileUploadService";
import { deleteFileGroup } from "../../../apis/sharedFolderApi";
import UploadDesignIntentProofscope from "../DesignJobs/UploadDesignIntentProofscope";
import { uploadtoAzurefileShare } from "../../../apis/uploadAzureFileShareApi";
import useAzureUploadFolderStructure from "../../../hooks/useAzureUploadFolderStructure";
import { useProofScopeURL } from "../../ProofScope/ViewFiles";
import { isEmpty, isString } from "lodash";
import { totalFileSizeQuotient } from "../../../constants/FileUploadConstant";
import {
  AzureContainerFail,
  AzureContainerSuccess,
  AzureFileShareFail,
  AzureFileShareSuccess,
  ContainerAndFileShareFailMsg,
  ContainerFailMsg,
  FileShareFailMsg,
} from "../../../Utils/constants";
import { SpecialProjectAction } from "../../../store/actions/ProjectSetupActions";
import { redirectUnallocatedLinksToArtworkStatus } from "../../../utils";
import { UnsavedChangesDialog, useUnsavedChangesWarning } from "../../common/NavigationPrompt";
import { getReadWriteAccessForTask, getUserAccessForTask } from "../../../Utils/helpers";
import UnAuthorizedComponent from "../../UnAuthorized/UnAuthorizedComponent";

const breadcrumb = [
  { label: "My Tasks", url: "/tasks" },
  { label: "Upload Regional Design Template" },
];

const URDT = () => {
  const toast = useRef(null);
  const [data, setData] = useState(null);
  const [date, setDate] = useState("");
  const [version, setVersion] = useState(0);
  const [designIntent, setDesignIntent] = useState(null);
  const [formattedValue, setformattedValue] = useState(0);
  const [fileName, setFileName] = useState("");
  const [viewFileName, setViewFileName] = useState("");
  const [azureFile, setAzureFile] = useState("");
  const [loader, setLoader] = useState(true);
  const [fileDetails, setFileDetails] = useState(null);
  const [taskStatus, setTaskStatus] = useState("");
  const [formData, setFormData] = useState(null);
  const [azureFileUploadMsg, setAzureFileUploadMsg] = useState(false);
  const [thumbnailErrorMsg, setThumbnailErrorMsg] = useState("");
  let { TaskID, page1, page2, pageType, ProjectID } = useParams();
  const [otherRefernceDocsForUI, setOtherRefernceDocsForUI] = useState([]);
  const [otherDocSeq, setOtherDocSeq] = useState(1);
  const { TaskDetailsData, loading } = useSelector((state) => state.TaskDetailsReducer);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const id = `${TaskDetailsData?.ArtworkAgilityTasks?.[0]?.Task_Key}`;
  const headerName = `${TaskDetailsData?.ArtworkAgilityTasks?.[0]?.TaskPlaceholderName}`;
  const shortName = TaskDetailsData?.ArtworkAgilityTasks?.[0]?.Task_Type;
  const roleName = "DI_";
  const location = useLocation();
  const currentUrl = location?.pathname;
  const ORDAFolderStructure = useAzureUploadFolderStructure("RDT", "", false);
  const folderStructure = useAzureUploadFolderStructure("RDT", version);
  const {
    userDetails: { UserGroup },
  } = useSelector((state) => state?.UserDetailsReducer);
  const User = useSelector((state) => state.UserReducer);
  const userInformation = User?.userInformation;
  const userAccessPayLoad = {
    ArtworkAgilityPage: {
      UserId: userInformation?.userid,
      ProjectID: ProjectID,
      UserGroup: UserGroup,
    },
  };
  const [accessType, setAccessType] = useState("Write");
  const [accessSecurityMatrix, setUserAccess] = useState(false);
  const [checkReadWriteAccess, setCheckReadWriteAccess] = useState(false);

  const env = getEnvironmentFromURL();
  const sanitizedBuName = sanitizeFileName(TaskDetailsData?.ArtworkAgilityTasks?.[0]?.BU);
  const sanitizedTaskFolder = sanitizeFileName(`RDT`);
  const { viewProofScopeFile } = useProofScopeURL();
  const [readonlyUrl, setReadonlyUrl] = useState("");
  const [pageEdited, setPageEdited] = useState(false);
  const [showDialog, setShowDialog] = useState(false);
  const [FileUploaded, setFileUploaded] = useState(false);
  const { markDirty, markClean } = useUnsavedChangesWarning();
  const [FormObjects, setFormObjects] = useState({ fileList: [] });
  const [InitialFormObjects, setInitialFormObjects] = useState({ fileList: [] });

  useEffect(() => {
    const isObjectEqual = JSON.stringify(InitialFormObjects) === JSON.stringify(FormObjects);
    if (!isObjectEqual && FileUploaded) {
      setPageEdited(true);
    } else {
      setPageEdited(false);
      setFileUploaded(false);
    }
  }, [FormObjects]);

  useEffect(() => {
    if (pageEdited) {
      markDirty();
    } else {
      markClean();
    }
  }, [pageEdited]);

  useEffect(() => {
    markClean();
    setPageEdited(false);

    return () => dispatch({ type: "GET_TASK_DETAILS_CLEAR" });
  }, []);

  useEffect(() => {
    setUserAccess(getUserAccessForTask(TaskDetailsData));
    setCheckReadWriteAccess(getReadWriteAccessForTask(TaskDetailsData));
    setAccessType(TaskDetailsData?.AccessType);
  }, [TaskDetailsData?.AccessType]);

  useEffect(() => {
    if (userInformation?.userid && UserGroup?.length) {
      setLoader(false);
      dispatch(getTaskDetails(TaskID, ProjectID, userAccessPayLoad));
      setAzureFileUploadMsg(false);
      setThumbnailErrorMsg("");
    }
  }, [dispatch, TaskID, ProjectID, userInformation?.userid, UserGroup?.length]);

  useEffect(() => {
    if (TaskDetailsData) {
      const otherRDData = [];
      setDesignIntent(TaskDetailsData?.ArtworkAgilityTasks?.[0]?.DesignJobDetails || []);
      setData(TaskDetailsData?.ArtworkAgilityTasks?.[0] || []);
      setTaskStatus(TaskDetailsData?.ArtworkAgilityTasks[0]?.Task_Status);
      const data =
        TaskDetailsData?.ArtworkAgilityTasks?.[0]?.DesignJobDetails?.[0]?.FileMetaDataList?.[0] ||
        [];
      const OtherReferenceDocData = Array.isArray(
        TaskDetailsData?.ArtworkAgilityTasks?.[0]?.DesignJobDetails?.[0]?.OtherReferenceDoc,
      )
        ? TaskDetailsData?.ArtworkAgilityTasks?.[0]?.DesignJobDetails?.[0]?.OtherReferenceDoc
        : [];
      const fileGroupsResult = groupFilesByFileGroup(OtherReferenceDocData);
      setOtherRefernceDocsForUI(fileGroupsResult || []);
      setOtherDocSeq(fileGroupsResult?.length || 1);
      const specialProjectFlag = TaskDetailsData?.SpecialProject;
      dispatch(SpecialProjectAction(specialProjectFlag));
      redirectUnallocatedLinksToArtworkStatus(currentUrl, specialProjectFlag, navigate);
      if (data) {
        data.Version !== "" && setVersion(data.Version);
        data.Timestamp !== "" &&
          setDate(moment(data.Timestamp, "YYYYMMDD[T]HHmmss.SSS [GMT]").format("DD-MMMM-YYYY"));
      }
    }
  }, [TaskDetailsData]);

  useEffect(() => {
    if (!isEmpty(readonlyUrl) && !isEmpty(formData)) {
      (async () => {
        const payload = { ...formData };
        if (!isEmpty(payload?.pageInstructions)) {
          payload.pageInstructions[0].content["ViewPFURL"] = readonlyUrl;
          // Ensure OtherReferenceDoc instructions are up-to-date at submission
          payload.pageInstructions = [
            payload.pageInstructions[0], // Keep the UploadRDTList instruction
            ...getOtherReferenceDocInstructions(), // Add fresh OtherReferenceDoc instructions
          ];
        }
        const headers = {
          key: "If-Match",
          value: TaskDetailsData?.ArtworkAgilityPage?.Etag,
        };
        await submitUploadRegionalDesignIntent(payload, id, headers);
        if (toast.current) {
          toast.current.show({
            severity: "success",
            summary: "File Uploaded",
            detail: "Successfully!",
            life: 3000,
          });
        }
        await dispatch(getTaskDetails(TaskID, ProjectID, userAccessPayLoad));
        redirectToProjectPlanOrTaskPage(page1, page2, pageType, ProjectID, navigate);
        setLoader(false);
        setAzureFileUploadMsg(false);
        setThumbnailErrorMsg("");
      })();
    }
  }, [readonlyUrl, formData]);

  useEffect(() => {
    if (
      (taskStatus !== "Complete" || taskStatus !== "Cancelled" || checkReadWriteAccess) &&
      (!otherRefernceDocsForUI || otherRefernceDocsForUI?.length === 0)
    ) {
      const defaultFileGroup = [
        {
          FileGroup: 1,
          Sequence: 1,
          FileMetaDataList: [
            {
              isNew: true,
              FileGroup: 1,
              Sequence: 1,
              File_Name: "",
              Version: 1,
              Email: "",
              FileID: "",
              File_Path: "",
              Full_Name: "",
              JobID: "",
              JobName: "",
              ReadOnlyURL: "",
              Timestamp: "",
              TypeOfFile: "",
            },
          ],
        },
      ];
      setOtherRefernceDocsForUI(defaultFileGroup);
    }
  }, [otherRefernceDocsForUI, taskStatus, checkReadWriteAccess]);

  function groupFilesByFileGroup(data) {
    // Chain filter and reduce for grouping
    const grouped = data
      .filter((f) => f.FileGroup !== "" && f.FileGroup !== undefined)
      .reduce((acc, file) => {
        if (!acc[file.FileGroup]) acc[file.FileGroup] = [];
        acc[file.FileGroup].push(file);
        return acc;
      }, {});

    // Build the output array with chained map and sort operations
    return Object.entries(grouped).map(([FileGroup, files]) => {
      const maxSequence = Math.max(...files.map((f) => Number(f.Sequence)));
      return {
        FileGroup,
        Sequence: maxSequence,
        FileMetaDataList: files
          .map((file) => ({
            ...file,
            FileGroup: file.FileGroup,
            Sequence: file.Sequence,
          }))
          .sort((a, b) => Number(b.Version) - Number(a.Version)),
      };
    });
  }

  const otherReferenceDocs = "Other Reference Documents & Assets";

  // ORDA file upload handler
  const onORDAFileUpload = (e, FileDetails, fileUploadSection, seq) => {
    if (fileUploadSection === otherReferenceDocs) {
      const fileGroup = FileDetails?.FileGroup != null ? String(FileDetails?.FileGroup) : undefined;
      const groupDetails = otherRefernceDocsForUI?.find(
        (group) => String(group?.FileGroup) === String(fileGroup),
      ) || [];
      
      fileOnFileUpload(
        e,
        FileDetails,
        fileUploadSection,
        seq,
        groupDetails,
        setOtherRefernceDocsForUI,
        orderBySequence,
      );
    }
  };

  // ORDA file clear handler
  const onORDAFileClear = async (fileUploadSection, fileListToRemove) => {
    if (fileUploadSection === otherReferenceDocs) {
      const { apiCall, updatedGroups } = onFileClearHandler(
        fileListToRemove,
        otherRefernceDocsForUI,
        setOtherRefernceDocsForUI,
        setLoader,
        {
          deleteFileGroupAPI: deleteFileGroup,
          ProjectID,
          TaskID: data?.Task_ID,
          Etag: TaskDetailsData?.ArtworkAgilityPage?.Etag,
        },
      );

      try {
        if (apiCall) await apiCall;
      } catch (error) {
        setLoader(false);
        return;
      }

      setOtherRefernceDocsForUI(updatedGroups);
      setLoader(false);
    }
  };

  const otherRDAddNewEmptyDesign = () => {
    onAddNewFilesHandler(otherRefernceDocsForUI, setOtherRefernceDocsForUI, setOtherDocSeq);
  };

  const handleCancel = () => {
    redirectToProjectPlanOrTaskPage(page1, page2, pageType, ProjectID, navigate);
  };

  const handleCancelClick = () => {
    if (pageEdited) {
      setShowDialog(true);
    } else {
      handleCancel();
    }
  };

  // it will hide warning dialog
  const cancelNavigation = () => {
    setShowDialog(false);
  };
  // it will navigate to previously saved url navigate(pendingNavigation);
  // by doing setShowDialog(false) and setPendingNavigation("");
  const confirmNavigation = () => {
    markClean();
    handleCancel();
    setShowDialog(false);
  };

  const BU = TaskDetailsData?.ArtworkAgilityTasks?.[0]?.BU;
  const projectName = TaskDetailsData?.ArtworkAgilityTasks?.[0]?.Project_Name;
  const filesexist =
    TaskDetailsData?.ArtworkAgilityTasks?.[0]?.DesignJobDetails?.[0]?.FileMetaDataList?.[0]
      ?.File_Name;

  // Define a function to generate the formData object
  const generateSaveAsDraftFormData = (filePath, fileValue) => {
    const fileSize = Math.round(formattedValue / totalFileSizeQuotient);
    return {
      AWMTaskID: TaskDetailsData?.ArtworkAgilityTasks?.[0]?.Task_ID,
      AWMProjectID: TaskDetailsData?.ArtworkAgilityPage?.AWM_Project_ID,
      Size: fileSize === 0 ? "1" : fileSize,
      Version: fileDetails?.Version,
      Filename: azureFile?.File_Name ? azureFile?.File_Name : fileValue,
      Filepath:
        filePath === ""
          ? TaskDetailsData?.ArtworkAgilityTasks?.[0]?.DesignJobDetails?.[0]?.FileMetaDataList?.[0]
              ?.File_Path
          : filePath,
      Full_Name: fileDetails?.Full_Name,
      Email: fileDetails?.Email,
    };
  };

  const getOtherReferenceDocObj = () => {
    const designJobDetails = TaskDetailsData?.ArtworkAgilityTasks?.[0]?.DesignJobDetails?.[0];
    
    return otherRefernceDocsForUI?.flatMap((group) =>
      group?.FileMetaDataList
        ?.filter((file) => file?.Info)
        .map((file) => {
          const fileSize = Math.round(file?.Info?.fileInfo?.size / totalFileSizeQuotient);
          return {
            FileGroup: group?.FileGroup,
            Version: file?.Info?.version,
            Size: fileSize === 0 ? "1" : `${fileSize}`,
            Sequence: `${file?.Info?.sequence}`,
            Filename: file?.File_Name,
            Full_Name: file?.Info?.Full_Name,
            Email: file?.Info?.Email,
            TypeOfFile: file?.File_Name?.split(".")?.pop(),
            JobID: designJobDetails?.Design_Job_ID,
            JobName: designJobDetails?.Design_Job_Name,
            Action: "add",
          };
        }),
    ) || [];
  };

  const getOtherReferenceDocInstructions = () => {
    return getOtherReferenceDocObj()
      ?.map((obj) => ({
        instruction: "APPEND",
        target: "OtherReferenceDoc",
        content: obj,
      })) || [];
  };

  const uploadOtherReferenceDocsToAzure = async () => {
    return await fileGetFilesListObj(
      otherRefernceDocsForUI,
      TaskDetailsData,
      ORDAFolderStructure,
      toast,
      uploadtoAzureStrContainer,
      AzureContainerSuccess,
      AzureContainerFail,
    );
  };

  const generateSubmitFormData = (filePath, fileValue) => {
    const fileSize = Math.round(formattedValue / totalFileSizeQuotient);
    const taskDetails = TaskDetailsData?.ArtworkAgilityTasks?.[0];
    const designJobDetails = taskDetails?.DesignJobDetails?.[0];
    const fileMetaData = designJobDetails?.FileMetaDataList?.[0];

    const pageInstructions = [
      {
        instruction: "APPEND",
        target: "UploadRDTList",
        content: {
          Action: "add",
          Filename: azureFile?.File_Name ?? fileValue,
          Size: fileSize === 0 ? "1" : fileSize,
          Filepath: filePath === "" ? fileMetaData?.File_Path : filePath,
          Version: fileDetails?.Version,
          Full_Name: fileDetails?.Full_Name,
          Email: fileDetails?.Email,
          JobID: designJobDetails?.Design_Job_ID,
          JobName: designJobDetails?.Design_Job_Name,
          TypeOfFile: azureFile?.File_Name?.split(".")?.pop() ?? fileValue?.split(".")?.pop(),
        },
      },
      ...getOtherReferenceDocInstructions(),
    ];

    return {
      caseTypeID: "PG-AAS-Work-UploadRegionalDesignTemplate",
      content: {
        AWMTaskID: taskDetails?.Task_ID,
        AWMProjectID: TaskDetailsData?.ArtworkAgilityPage?.AWM_Project_ID,
      },
      pageInstructions,
    };
  };

  const onSaveAsDraft = async () => {
    setLoader(true);
    try {
      if (!(filesexist === azureFile) && azureFile !== "") {
        await uploadtoAzureStrContainer(azureFile, folderStructure);

        let res = await uploadtoAzurefileShare(
          azureFile?.file ? azureFile?.file : azureFile ? azureFile : filesexist,
          BU,
          `RDT`,
          ProjectID,
          TaskDetailsData?.ArtworkAgilityTasks?.[0]?.DesignJobDetails?.[0].Design_Job_ID,
          version,
        );

        if (res) {
          // Use the response from uploadtoAzurefileShare as the file name
          // Replace with the actual property name from the response

          const fileurl =
            fileName !== "" && fileName?.endsWith(".zip")
              ? sanitizeFileName(res)
              : fileName !== "" && !fileName?.endsWith(".zip")
                ? sanitizeFileName(fileName)
                : sanitizeFileName(filesexist);

          const thumnailResponse = await viewThumbnail(
            env,
            sanitizedBuName,
            sanitizedTaskFolder,
            fileurl,
            TaskID,
            ProjectID,
            TaskDetailsData?.ArtworkAgilityTasks?.[0]?.DesignJobDetails?.[0].Design_Job_ID,
            version,
          );
          if (fileName?.endsWith(".zip")) {
            setFileName(res);
            setAzureFile(res);
          }
          if (thumnailResponse.thumbnail) {
            const formData = generateSaveAsDraftFormData(thumnailResponse.thumbnail, fileurl);
            await postSaveDesignIntent(formData);

            if (toast.current) {
              toast.current.show({
                severity: "success",
                summary: "File Uploaded",
                detail: "Successfully!",
                life: 3000,
              });
            }

            await dispatch(getTaskDetails(TaskID, ProjectID, userAccessPayLoad));
            setLoader(false);
            setAzureFileUploadMsg(false);
          } else {
            setLoader(false);
            setAzureFileUploadMsg(true);
          }
        }
      } else {
        if (
          TaskDetailsData?.ArtworkAgilityTasks?.[0]?.Task_Status === "In-Progress" &&
          filesexist !== ""
        ) {
          if (toast.current) {
            toast.current.show({
              severity: "success",
              summary: "File Uploaded",
              detail: "Successfully!",
              life: 3000,
            });
          }

          const formData = generateSaveAsDraftFormData("", filesexist);
          await postSaveDesignIntent(formData);
          await dispatch(getTaskDetails(TaskID, ProjectID, userAccessPayLoad));
          setLoader(false);
          setAzureFileUploadMsg(false);
        } else {
          setLoader(false);
          setAzureFileUploadMsg(false);
        }
      }
    } catch (error) {
      console.error("An error occurred:", error);
      setLoader(false);
    }
  };

  const onSubmit = async () => {
    setLoader(true);

    const headers = {
      key: "If-Match",
      value: TaskDetailsData?.ArtworkAgilityPage?.Etag,
    };
    try {
      if (!(filesexist === azureFile) && azureFile !== "") {
        Promise.all([
          uploadtoAzureStrContainer(azureFile, folderStructure),
          uploadtoAzurefileShare(
            azureFile.file ? azureFile.file : azureFile ? azureFile : filesexist,
            BU,
            `RDT`,
            ProjectID,
            TaskDetailsData?.ArtworkAgilityTasks?.[0]?.DesignJobDetails?.[0].Design_Job_ID,
            version,
          ),
        ])
          .then(function (responses) {
            const azureRes = responses[0];
            const res = responses[1];
            if (azureRes) {
              if (toast.current) {
                toast.current.show(AzureContainerSuccess);
              }
            } else {
              if (toast.current) {
                toast.current.show(AzureContainerFail);
              }
            }
            if (res) {
              if (toast.current) {
                toast.current.show(AzureFileShareSuccess);
              }
            } else {
              if (toast.current) {
                toast.current.show(AzureFileShareFail);
              }
            }
            return responses;
          })
          .then(async (data) => {
            const azureRes = data[0];
            const res = data[1];
            if (azureRes && res) {
              const fileurl =
                fileName !== "" && fileName?.endsWith(".zip")
                  ? sanitizeFileName(res)
                  : fileName !== "" && !fileName?.endsWith(".zip")
                    ? sanitizeFileName(fileName)
                    : sanitizeFileName(filesexist);
              const thumnailResponse = await viewThumbnail(
                env,
                sanitizedBuName,
                sanitizedTaskFolder,
                fileurl,
                TaskID,
                ProjectID,
                TaskDetailsData?.ArtworkAgilityTasks?.[0]?.DesignJobDetails?.[0].Design_Job_ID,
                version,
              );

              if (fileName?.endsWith(".zip")) {
                setFileName(res);
                setAzureFile(res);
              }
              if (thumnailResponse.thumbnail) {
                const designJobId = sanitizeFileName(
                  TaskDetailsData?.ArtworkAgilityTasks?.[0]?.DesignJobDetails?.[0].Design_Job_ID,
                );
                const fileVersion = isString(version)
                  ? version.substring(0, 1) + (parseInt(version.substring(1)) + 1)
                  : version;
                const assignee = TaskDetailsData?.ArtworkAgilityTasks?.[0]?.Assignee;
                const filePath = `cloudflow://awm/${env}/${sanitizedBuName}/${sanitizedTaskFolder}/${ProjectID}/${designJobId}/${fileVersion}/${fileurl}`;

                // await viewProofScopeFile(
                //   ProjectID,
                //   id,
                //   TaskID,
                //   filePath,
                //   assignee,
                //   "UploadRegionalDesignTemplate",
                //   "UploadRegionalDesignTemplate_Flow",
                //   1
                // );
                setReadonlyUrl(thumnailResponse.readonly_url);

                // Upload OtherReferenceDoc files to Azure
                await uploadOtherReferenceDocsToAzure();
                const formData = generateSubmitFormData(thumnailResponse.thumbnail, fileurl);
                setFormData(formData);
              } else {
                setLoader(false);
                setAzureFileUploadMsg(true);
                setThumbnailErrorMsg(thumnailResponse?.contents?.message);
              }
            } else {
              const msg =
                !azureRes && !res
                  ? ContainerAndFileShareFailMsg
                  : !azureRes
                    ? ContainerFailMsg
                    : !res
                      ? FileShareFailMsg
                      : "File upload failed!  Please try after some time.";
              setLoader(false);
              setAzureFileUploadMsg(true);
              setThumbnailErrorMsg(msg);
            }
          });
      } else {
        if (
          TaskDetailsData?.ArtworkAgilityTasks?.[0]?.Task_Status === "In-Progress" &&
          filesexist !== ""
        ) {
          // Upload OtherReferenceDoc files to Azure
          await uploadOtherReferenceDocsToAzure();
          const formData = generateSubmitFormData("", filesexist);
          await submitUploadRegionalDesignIntent(formData, id, headers);
          if (toast.current) {
            toast.current.show({
              severity: "success",
              summary: "File Uploaded",
              detail: "Successfully!",
              life: 3000,
            });
          }
          await dispatch(getTaskDetails(TaskID, ProjectID, userAccessPayLoad));
          redirectToProjectPlanOrTaskPage(page1, page2, pageType, ProjectID, navigate);
          setLoader(false);
          setAzureFileUploadMsg(false);
          setThumbnailErrorMsg("");
        }
      }
    } catch (error) {
      console.error("An error occurred:", error);
      setLoader(false);
    }
  };

  return (
    <PageLayout>
      <Toast ref={toast} />
      {loading || loader || designIntent === null ? (
        <LoadingOverlay
          active={loading || loader || designIntent === null}
          spinner
          text=""
          className="overlay-loader"
        />
      ) : accessSecurityMatrix ? (
        <>
          <DesignHeader
            breadcrumb={breadcrumb}
            headerName={headerName}
            disabled={true}
            label={shortName}
            lastLabel={"URDT"}
            pageEdited={pageEdited}
            setPageEdited={setPageEdited}
            checkReadWriteAccess={checkReadWriteAccess}
            actionButtonsFlag={true}
            {...data}
          />
          <div className="task-details">
            {
              <AddNewDesign
                {...data}
                checkReadWriteAccess={checkReadWriteAccess}
                TaskDetailsData={TaskDetailsData}
                setPageEdited={setPageEdited}
                pageEdited={pageEdited}
              />
            }
            {designIntent && (
              <UploadDesignIntentProofscope
                {...designIntent}
                designIntent={designIntent}
                upload={true}
                setPageEdited={setPageEdited}
                pageEdited={pageEdited}
                setformattedValue={setformattedValue}
                setAzureFile={setAzureFile}
                azureFile={azureFile}
                setFileName={setFileName}
                item={data}
                roleName={roleName}
                setFormObjects={setFormObjects}
                setFileUploaded={setFileUploaded}
                ArtworkAgilityPage={TaskDetailsData?.ArtworkAgilityPage}
                version={version}
                setVersion={setVersion}
                date={date}
                checkReadWriteAccess={checkReadWriteAccess}
                fileName={fileName}
                buName={BU}
                taskFolder="RDT"
                TaskID={TaskID}
                projectName={projectName}
                ProjectID={ProjectID}
                viewFileName={viewFileName}
                setViewFileName={setViewFileName}
                setAzureFileUploadMsg={setAzureFileUploadMsg}
                setFileDetails={setFileDetails}
                toShowReferenceDocuments={false}
                toShowORDA={true}
                loading={loading}
                azureFileUploadMsg={azureFileUploadMsg}
                thumbnailErrorMsg={thumbnailErrorMsg}
                otherRefernceDocsForUI={otherRefernceDocsForUI}
                setOtherRefernceDocsForUI={setOtherRefernceDocsForUI}
                otherDocSeq={otherDocSeq}
                setOtherDocSeq={setOtherDocSeq}
                onORDAFileUpload={onORDAFileUpload}
                onORDAFileClear={onORDAFileClear}
                otherRDAddNewEmptyDesign={otherRDAddNewEmptyDesign}
                azureSubFolder="RDT"
              />
            )}
          </div>

          <FooterButtons
            accessType={accessType}
            handleCancel={handleCancelClick}
            onSaveAsDraft={onSaveAsDraft}
            onSubmit={onSubmit}
            hideSaveButton={true}
            checkReadWriteAccess={checkReadWriteAccess}
            bottomFixed={true}
            formValid={
              fileName === "" ||
              TaskDetailsData?.ArtworkAgilityTasks?.[0]?.Task_Status === "Complete" ||
              TaskDetailsData?.ArtworkAgilityTasks?.[0]?.Task_Status === "Cancelled"
            }
            {...data}
          />
          {/* UnsavedChangesDialog popup*/}
          <UnsavedChangesDialog
            visible={showDialog}
            onCancel={cancelNavigation}
            onConfirm={confirmNavigation}
          />
        </>
      ) : (
        <UnAuthorizedComponent nowrapper={true} />
      )}
    </PageLayout>
  );
};
export default URDT;
